
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/productos/novedades",
      function () {
        return require("private-next-pages/productos/novedades/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/productos/novedades"])
      });
    }
  